export default "__VITE_ASSET__BIiAf_pV__"